// Zentrale Konfigurationswerte aus den .env-Dateien
export const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
export const WS_URL = import.meta.env.VITE_APP_WS_URL;
export const APP_DOMAIN = import.meta.env.VITE_APP_DOMAIN;
export const APP_FULL_URL = import.meta.env.VITE_APP_FULL_URL;

// Konfiguration für sichere Cookies
export const COOKIE_OPTIONS = {
  path: '/',
  domain: APP_DOMAIN,
  secure: import.meta.env.PROD, // true in Produktion
  sameSite: 'Lax'
};

